import { isObject } from '@bugsnag/core-performance';

const isRoutingProvider = (value) => isObject(value) &&
    typeof value.resolveRoute === 'function' &&
    typeof value.listenForRouteChanges === 'function';

export { isRoutingProvider };
